import { connect } from "react-redux";
import { dealColumns } from "_constants";
import { closeModal } from "actions/modals";
import { saveUser } from "actions/user";
import { withFormik } from "formik";
import includes from "lodash/includes";

import DealColumnsForm from "./DealColumnsForm";

const form = withFormik({
  displayName: "dealColumns",
  enableReinitialize: true,
  mapPropsToValues: ({ columns }) => ({
    ...dealColumns.reduce((acc, curr) => {
      acc[curr] = includes(columns, curr);

      return acc;
    }, {}),
  }),
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
})(DealColumnsForm);

const mapStateToProps = ({
  currentUser: {
    company: { limitations },
    dealColumns: columns,
  },
}) => ({
  columns,
  limitations,
});

const mapDispatchToProps = (dispatch, { userID }) => ({
  onSubmit: (columns) =>
    dispatch(
      saveUser({
        user: {
          id: userID,
          dealColumns: dealColumns.reduce((acc, c) => {
            if (columns[c]) acc.push(c);

            return acc;
          }, []),
        },
      })
    ).then(() => dispatch(closeModal("DealColumnsModal"))),
});

export default connect(mapStateToProps, mapDispatchToProps)(form);
